<mat-card appearance="outlined">
  <mat-card-header class="mb-5">
    <mat-card-title>
        <h1 i18n>New Workflow: Basic information</h1>
    </mat-card-title>
    <mat-card-subtitle i18n>
      Before you can start building your workflow we need just few basic information.
    </mat-card-subtitle>
  </mat-card-header>
    <mat-card-content>
      <form [formGroup]="form">
        <mat-form-field appearance="outline">
          <mat-label i18n>Workflow name</mat-label>
          <input matInput type="text"
                 formControlName="name"
                 placeholder="Name of your new workflow..."
                 required>
          <mat-hint i18n>Workflow name is used for internal purposes only, it is not visible to the public.</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>Who can initiate workflow?</mat-label>
          <mat-select formControlName="selectedRoles" multiple required>
              <mat-optgroup *ngFor="let group of rolesSelectData" [label]="group.name">
                  <mat-option *ngFor="let role of group.items" [value]="role.id" [title]="role.name">{{ role.name }}</mat-option>
              </mat-optgroup>
          </mat-select>
          <mat-hint i18n>Role(s) which can initiate this workflow.</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>First state name</mat-label>
          <input matInput
                 type="text"
                 formControlName="state"
                 placeholder="Name of the workflow first state..."
                 required>
          <mat-hint i18n>Workflow needs to have a starting point - first state. Feel free to change the state name according to your needs.</mat-hint>
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions align="end">
        <button mat-flat-button type="submit"
                                color="primary"
                                (click)="onContinue()"
                                [disabled]="form.invalid"
                                i18n>Continue</button>
    </mat-card-actions>
</mat-card>